<template>
    <div
        v-if="consultation !== null"
        class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <consultation-timer
                        user-type="admin"
                        show-consultation-status
                        :consultation="consultation"
                        :doctor="consultation.doctor"
                        :timezone="timezone">
                    </consultation-timer>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 col-lg-6 mb-3">
                <template v-if="$store.state.configs.admin_agora == 1">
                    <div
                        v-if="!consultation.started_at && !isClosed"
                        class="row">
                        <div class="col-md-12 mb-3">
                            <div class="vc-pre d-flex justify-content-center align-items-center">
                                <div>
                                    <div class="vc-pre__message-wrapper">
                                        <p class="vc-pre__message">{{ preMessage }}</p>
                                    </div>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <b-button
                                            variant="yokumiru-white"
                                            class="ml-2 mr-2 vc-btn-back text-muted"
                                            href="/admin/consultations">
                                            {{ $locale.consultation_host }}一覧へ戻る
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-show="isHold"
                        class="row">
                        <div class="col-md-12 mb-3">
                            <div v-if="consultation.doctor !== null">
                                <admin-video-stream-agora
                                    :room-key="consultation.room_key"
                                    :api-key="apiKey"
                                    :token="token"
                                    :transcode="transcode"
                                    :debug="debug"
                                    :user="consultation.user"
                                    :doctor="consultation.doctor"
                                    :consultation="consultation">
                                </admin-video-stream-agora>
                            </div>
                            <div class="vc-consultation-close d-flex justify-content-center align-items-center">
                                <b-button
                                    variant="yokumiru-white"
                                    class="ml-2 mr-2 vc-btn-back text-muted"
                                    :href="previousUrl !== null ? previousUrl : '/admin/consultations'">
                                    {{ $locale.consultation_host }}一覧へ戻る
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="isClosed"
                        class="row">
                        <div class="col-md-12 mb-3">
                            <div class="vc-pre d-flex justify-content-center align-items-center">
                                <div>
                                    <div class="vc-pre__message-wrapper">
                                        <p class="vc-pre__message">
                                            {{ $locale.consultation_host }}は{{ consultation.flg_cancel ? 'キャンセルされました' : '終了しました' }}
                                        </p>
                                    </div>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <b-button
                                            variant="yokumiru-white"
                                            class="ml-2 mr-2 vc-btn-back text-muted"
                                            href="/admin/consultations">
                                            {{ $locale.consultation_host }}一覧へ戻る
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <div class="vc-pre d-flex justify-content-center align-items-center">
                                <b-button
                                    variant="yokumiru-white"
                                    class="ml-2 mr-2 vc-btn-back text-muted"
                                    href="/admin/consultations">
                                    {{ $locale.consultation_host }}一覧へ戻る
                                </b-button>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="row">
                    <div class="col-md-12 mb-3">
                        <div
                            v-if="isFetchedDoctorMenu"
                            class="mb-3">
                            <b-card no-body>
                                <b-tabs card>
                                    <b-tab>
                                        <template v-slot:title>会員情報</template>
                                        <b-container>
                                            <div class="d-md-block d-flex justify-content-center">
                                                <user-profile
                                                    :user="consultation.user"
                                                    :doctor-id="consultation.doctor_id" userType="admin">
                                                </user-profile>
                                            </div>
                                        </b-container>
                                    </b-tab>
                                    <b-tab v-if="doctorMenu !== null">
                                        <template v-slot:title>予約メニュー</template>
                                        <b-container>
                                            <div class="doctorMenu">
                                                <doctor-menu-info
                                                    :menu="doctorMenu"
                                                    :consultation="consultation"
                                                    doctor-introduction-type="history">
                                                </doctor-menu-info>
                                            </div>
                                        </b-container>
                                    </b-tab>
                                    <b-tab v-else-if="consultation.doctor !== null">
                                        <template v-slot:title>医師情報</template>
                                        <b-container>
                                            <doctor-profile
                                                :doctor-id="consultation.doctor.id"
                                                is-only-content>
                                            </doctor-profile>
                                        </b-container>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-6 mb-3">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <b-card no-body>
                            <b-tabs v-model="tabIndex" card>
                                <b-tab>
                                    <template v-slot:title>
                                        <b-icon-file-earmark-text></b-icon-file-earmark-text>&nbsp;{{ $locale.question }}
                                    </template>
                                    <b-container>
                                        <div class="c-box-scroll c-box-scroll--500">
                                            <admin-doctor-interview-answers
                                                :consultation-id="consultation.id"
                                                :flg-reserved-by-doctor="!!consultation.flg_reserved_by_doctor"
                                                :is-only-content="1">
                                            </admin-doctor-interview-answers>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab :title-item-class="tabCSS.chat" @click="chatTabClick">
                                    <template v-slot:title>
                                        <b-icon-chat-dots-fill></b-icon-chat-dots-fill>&nbsp;チャット
                                    </template>
                                    <b-container @click="chatTabClick">
                                        <div class="pb-5">
                                            <admin-chat
                                                :consultation="consultation"
                                                :timezone="timezone"
                                                is-only-content>
                                            </admin-chat>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab @click="medicalRecordTabClick">
                                    <template v-slot:title>
                                        <b-icon-clipboard-data></b-icon-clipboard-data>&nbsp;{{ `${$locale.consultation_host}記録` }}
                                    </template>
                                    <b-container>
                                        <div v-if="consultation.medical_record &&
                                            typeof consultation.medical_record.body === 'string' &&
                                            consultation.medical_record.body.length > 0">
                                            <medical-record-viewer :medical-record="consultation.medical_record"/>
                                        </div>
                                        <div v-else>
                                            <p class="mb-0 text-muted">{{ $locale.consultation_host }}記録は未入力です。</p>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab :title-item-class="tabCSS.image">
                                    <template v-slot:title>
                                        <svg class="b-tab-icon-camera" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve">
                                            <g>
                                                <path d="M8,5.6c-1.7,0-3,1.4-3,3s1.4,3,3,3s3-1.4,3-3S9.7,5.6,8,5.6z"/>
                                                <path d="M14.4,4.4h-2.1l-1-2.5H4.8l-1,2.5H3.5V3.1H2v1.3H1.7C1,4.4,0.5,4.9,0.5,5.6V13c0,0.7,0.6,1.2,1.2,1.2h12.7
                                                c0.7,0,1.2-0.6,1.2-1.2V5.6C15.6,4.9,15,4.4,14.4,4.4z M3,4.4H2.5V3.6H3V4.4z M8,13.2c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5
                                                s4.5,2,4.5,4.5S10.5,13.2,8,13.2z M13.5,7.4c-0.6,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1S14.1,7.4,13.5,7.4z"/>
                                            </g>
                                        </svg>&nbsp;撮影画像
                                    </template>
                                    <b-container>
                                        <div class="c-box-scroll c-box-scroll--500">
                                            <admin-doctor-consultation-images
                                                :consultation-id="consultation.id"
                                                :is-only-content="true">
                                            </admin-doctor-consultation-images>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab :title-item-class="tabCSS.attached_image">
                                    <template v-slot:title>
                                        <b-icon-images></b-icon-images>&nbsp;添付画像
                                    </template>
                                    <b-container>
                                        <div class="c-box-scroll c-box-scroll--500">
                                            <admin-doctor-consultation-attached-images
                                                :consultation-id="consultation.id"
                                                :is-only-content="true">
                                            </admin-doctor-consultation-attached-images>
                                        </div>
                                    </b-container>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </div>

                <div
                    v-if="doctorMenu && doctorMenu.is_health_package"
                    class="row">
                    <div class="col-md-12 mb-3">
                        <b-card no-body>
                            <b-tabs card>
                                <b-tab>
                                    <template v-slot:title>
                                        法人フィードバック
                                    </template>
                                    <b-container>
                                        <div v-if="consultation.consultation_feedback &&
                                                typeof consultation.consultation_feedback.opinion === 'string' &&
                                                consultation.consultation_feedback.opinion.length > 0">
                                            <consultation-feedback-viewer :feedback="consultation.consultation_feedback"/>
                                        </div>
                                        <div v-else>
                                            <p class="mb-0 text-muted">法人フィードバックは未入力です。</p>
                                        </div>
                                    </b-container>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </div>

                <div
                    v-if="$store.state.configs.medical_record_can_export == 1 && consultation.medical_record !== null"
                    class="d-flex justify-content-end">
                    <template v-if="medicalRecordUrl === null">
                        <div
                            v-if="inProgressExport"
                            class="d-flex align-items-center">
                            <b-spinner variant="yokumiru-admin" small></b-spinner>
                            <span class="ml-2 mr-2 text-muted">エクスポート中です…</span>
                        </div>
                        <b-button
                            v-else
                            @click="onClickExportMedicalRecord"
                            variant="yokumiru-admin">
                            {{ `${$locale.question}をエクスポート` }}
                        </b-button>
                    </template>
                    <template v-else>
                        <a :href="medicalRecordUrl" target="_blank" class="medicalRecordUrl">{{ `${$locale.consultation_host}内容をダウンロード` }}</a>
                    </template>
                </div>
            </div>
        </div>

        <image-modal/>
        <delete-file-modal user-type="admin"/>
        <admin-export-medical-record-modal/>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import Echo from 'laravel-echo'

    export default {
        name: 'AdminConsultation',

        props: {
            consultationData: {
                type: Object,
                required: true,
            },
            timezone: {
                type: String,
                required: true,
            },
            apiKey: {
                type: String,
                default: '',
            },
            token: {
                type: String,
                default: '',
            },
            transcode: {
                type: String,
                default: 'rtc', // rtc or live
            },
            videoProfile: {
                type: String,
                default: '480p_4',
            },
            debug: {
                type: String,
                default: '0',
            },
            previousUrl: {
                type: String|null,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                consultation: null,
                consultationFeedback: null,
                tabIndex: 0,
                tabCSS: {
                    chat: '',
                    image: '',
                    attached_image: '',
                },
                canStartTimeElapsed: false,
                doctorMenu: null,
                isFetchedDoctorMenu: false,
                medicalRecordUrl: null,
                inProgressExport: false,
            }
        },

        computed: {
            /**
             * 相談開始可能判定
             *
             * @return {boolean}
             */
            canStart: function () {
                if (!this.consultation || this.consultation.flg_cancel) {
                    return false
                }

                if (!constants.consultations.canStartDoctorAll.includes(this.consultation.status)) {
                    return false
                }

                return this.canStartTimeElapsed
            },

            /**
             * 相談中判定
             *
             * @return {boolean}
             */
            isHold: function () {
                return this.consultation && this.consultation.status === constants.consultations.hold
            },

            /**
             * 相談終了／キャンセル済み判定
             *
             * @return {boolean}
             */
            isClosed: function () {
                return this.consultation && constants.consultations.closedAll.includes(this.consultation.status)
            },

            /**
             * 相談開始前メッセージ
             *
             * @return {string}
             */
            preMessage: function () {
                if (this.canStart) {
                    return `医師が${this.$locale.consultation_host}を開始するとビデオ通話が表示されます`
                }
                return `予定開始時刻の${this.$store.state.configs.consultation_enter_min_start}分前までお待ちください`
            },
        },

        created: function() {
            // pusherの同時接続数を抑えるようにする
            // @see https://github.com/sewii/Yokumiru/issues/617
            window.Pusher = require('pusher-js')
            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: process.env.MIX_PUSHER_APP_KEY,
                cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                encrypted: true,
                disableStats: true,
                forceTLS: true,
            })

            this.consultation = this.consultationData
            this.fetchDoctorMenu()

            bus.$on('update-tab-css', this.updateTabCSS)
            bus.$on('can-start-time-elapsed', () => this.canStartTimeElapsed = true)
            bus.$on('medical-record-validation-failed', this.switchToMedicalRecordTab)
            bus.$on('admin-medical-record-exporting', () => this.inProgressExport = true)
        },

        beforeDestroy: function () {
            bus.$off('update-tab-css')
            bus.$off('can-start-time-elapsed')
            bus.$off('medical-record-validation-failed')
            bus.$off('admin-medical-record-exporting')
        },

        mounted: function () {
            if (this.$store.state.configs.admin_agora == 1) {
                if (this.isHold) {
                    bus.$emit('admin-agora-init')
                }

                window.Echo.private(`consultation.${this.consultation.id}`)
                    .listen('ConsultationConfirmed', () => {
                        // 相談予約確定時
                        this.fetchConsultation()
                    })
                    .listen('ConsultationDoctorAbsent', () => {
                        // 未入室終了（医師）
                        this.fetchConsultation()
                    })
                    .listen('ConsultationUserAbsent', () => {
                        // 未入室終了（ユーザ）
                        this.fetchConsultation()
                    })
                    .listen('ConsultationUserEntered', () => {
                        // ユーザ入室時
                        this.fetchConsultation()
                    })
                    .listen('ConsultationCanceled', () => {
                        // 相談キャンセル時
                        this.fetchConsultation()
                    })
                    .listen('ConsultationFinished', () => {
                        // 相談終了時（入室可能時間の超過時を含む）
                        this.fetchConsultation()
                    })
                    .listen('ConsultationStarted', () => {
                        // 相談開始時（医師が相談開始ボタンを押下）
                        this.fetchConsultation()
                        bus.$emit('admin-agora-init')
                    })
                    .listen('MedicalRecordUpdated', () => {
                        // 相談記録更新時
                        this.fetchConsultation()
                    })
                    .listen('ConsultationFeedbackUpdated', () => {
                        // 法人フィードバック更新時
                        this.fetchConsultation()
                    })
                    .listen('MedicalRecordExported', (e) => {
                        // 相談記録PDFエクスポート完了時
                        this.medicalRecordUrl = e.signed_url
                        this.inProgressExport = false
                        this.queueCwLogs(`[user:web] pusher event 'MedicalRecordExported' listened.`)
                    })
            }
        },

        methods: {
            /**
             * 医師メニュー詳細取得
             */
            fetchDoctorMenu: async function () {
                this.doctorMenu = null
                if (this.consultation.doctor_menu_id) {
                    await axios.get(`${constants.admin.doctor_menus.endpoint.base}/${this.consultation.doctor_menu_id}`)
                        .then(({data}) => {
                            this.doctorMenu = data.data
                        })
                }
                this.isFetchedDoctorMenu = true
            },

            /**
             * 相談記録エクスポートボタン押下時
             */
            onClickExportMedicalRecord: function () {
                if (this.consultation.medical_record !== null) {
                    bus.$emit('open-modal-admin-export-medical-record', this.consultation.medical_record)
                }
            },

            updateTabCSS: function (tabName, exists) {
                this.tabCSS[tabName] = exists ? 'b-tab-content-exists-admin' : ''
            },

            chatTabClick: function (e) {
                if (e.target.classList.contains('nav-link')) {
                    this.$nextTick(() => {
                        const el = document.getElementById('chat_message_only_content')
                        if (el) el.focus()
                        bus.$emit('chat-scroll')
                    })
                }
            },

            medicalRecordTabClick: function(){
                this.$nextTick(() => {
                    const el = document.getElementById('medical_record_edit')
                    if (el) el.focus()
                })
            },

            /**
             * 診療予約の取得
             */
            fetchConsultation: function () {
                axios.get(`${constants.admin.consultations.endpoint.base}/${this.consultation.id}`)
                    .then(({data}) => {
                        this.refreshConsultation(data)
                    })
            },

            /**
             * APIリクエスト後の相談予約データでリフレッシュ
             *
             * @param {object} consultation
             */
            refreshConsultation: function (consultation) {
                this.consultation = consultation
            },

            /**
             * 相談記録タブにスイッチ
             */
            switchToMedicalRecordTab: function () {
                this.tabIndex = 2
            },
        }
    }
</script>

<style lang="scss" scoped>
.medicalRecordUrl {
    margin-right: 10px;
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }
}

.doctorMenu {
    position: relative;
    display: block;
    vertical-align: top;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    padding: 25px;
    background-color: #f9f9f9;
    border: 1px solid #dee2e6;
    border-radius: 6px;
}

.vc-pre {
    min-height: 350px;
    padding: 30px;
    background: #808080;
    border: 1px solid #808080;
    border-radius: 4px;
    box-sizing: border-box;

    .vc-pre__message-wrapper {
        margin-bottom: 15px;
    }

    .vc-pre__message {
        margin-bottom: 5px;
        color: #fff;
        font-size: 1rem;
        font-weight: bold;
        text-align: center;
    }

    .vc-pre__message-sub {
        color: #fff;
        font-size: 0.8rem;
        font-weight: normal;
        text-align: center;
    }

    button, .vc-btn-back {
        box-shadow: 0 2px 5px rgba(0,0,0,0.125);
    }
}

.vc-consultation-close {
    padding: 10px;
    background: #fff;
    border-radius: 0 0 4px 4px;
}
</style>
